export default function getTypeFromUri(uri) {
  if (!uri) return null;
  if (uri === 'spotify:collection') return 'your-library';
  const [, type, playlistType, isMix] =
    uri.match(
      /^spotify:(?:(?:user:[^:]+:)?(collection(?::(?:tracks|albums|artists))?|[^:]+))(?::[^:]+:(playlist|rootlist))?(:user:[^:]+:cluster)?/
    ) || [];
  return isMix ? 'mix' : playlistType || type.replace(':', '-');
}
